module.exports = __webpack_public_path__ + "img/how__visual-2@2x.cfd44003.jpg";